"use strict";

window.Certifications.Components.CertifierProfilePreview = createReactClass({
  propTypes() {
    return {
      certifier: PropTypes.object.isRequired
    };
  },
  render() {
    return /* @__PURE__ */React.createElement(Components.Application.User.ProfilePreviewAffiliation, {
      profile: this.props.certifier
    });
  }
});